<template>
  <div
    class="quiz-answer-selector"
    :class="{ 'is-selected': isSelected }"
    role="checkbox"
    tabindex="0"
    :aria-checked="isSelected ? 'true' : 'false'"
    @click="handleCheckboxClick"
    @keydown.space.prevent="handleCheckboxClick"
    @keydown.enter.prevent="handleCheckboxClick"
  >
    <div class="checkbox-container">
      <!-- Circle checkbox for Not Selected -->
      <div
        v-if="!isSelected"
        class="checkbox checkbox-circle"
      ></div>
      <!-- Square checkbox for Selected -->
      <div v-else class="checkbox checkbox-square checkbox-selected">
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 3L4.5 8.5L2 6"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <div class="answer-text">
      {{ answer }}
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  answer: {
    type: String,
    required: true,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["select", "update:isSelected"]);

const handleCheckboxClick = () => {
  const nextValue = !props.isSelected;
  emit("update:isSelected", nextValue);
  emit("select", nextValue);
};
</script>

<style scoped>
.quiz-answer-selector {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0px;
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.quiz-answer-selector:focus-visible {
  outline: 2px solid #7f56d9;
  outline-offset: 2px;
}

.checkbox-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.checkbox-circle {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 1.5px solid #d0d5dd;
  background: #fff;
  cursor: pointer;
}

.checkbox-square {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 1.5px solid #7f56d9;
  background: #7f56d9;
}

.answer-text {
  color: #344054;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.is-selected .answer-text {
  color: #101828;
}
</style>
